import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Popper } from "@mui/material";

const UploadablefileGuideTooltip = ({ maximumSize, minimumImageSize, type, placement }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();

    const open = Boolean(anchorEl);
    const tooltipId = open ? "simple-popper" : undefined;

    const handleClick = (e) => {
        setAnchorEl(anchorEl ? null : e.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
    };
    return (
        <div className="popper-tooltip" onMouseLeave={handleClose} style={{ marginLeft: `8px` }}>
            <i
                className="sprite sprite-info"
                aria-describedby={tooltipId}
                onClick={(e) => handleClick(e)}
                onMouseEnter={(e) => handleClick(e)}
            ></i>
            <Popper id={tooltipId} open={open} anchorEl={anchorEl} placement={placement ? "bottom-start" : "bottom"}>
                <div className="popper-tooltip-content popper-tooltip-content-guide">
                    <div className="popper-tooltip-header">
                        <strong>{t(`common::label::${"Upload rules"}`)}</strong>
                        <button type="button" className="btn btn-icon-solid" onClick={handleClose}>
                            <i className="sprite sprite-cancel-lg" />
                        </button>
                    </div>
                    <div className={"popper-tooltip-body"}>
                        <ul className={"list-dot"}>
                            {maximumSize && (
                                <li>
                                    <p className={"dot"}>{t(`common::label::${"Maximum object size"}`)}</p>
                                    <div className={"text-secondary"}>
                                        <p>{maximumSize}</p>
                                    </div>
                                </li>
                            )}
                            {minimumImageSize && (
                                <li>
                                    <p className={"dot"}>{t(`common::label::${"Minimum Image Size"}`)}</p>
                                    <div className={"text-secondary"}>{minimumImageSize}</div>
                                </li>
                            )}
                            {type !== "local" && !type && (
                                <li>
                                    <p className={"dot"}>{t(`common::label::${"Supported URL patterns"}`)}</p>
                                    <div className={"text-secondary"}>
                                        {`https://s3.{region}.amazonaws.com/{bucket}/{filepath}`}
                                        <br />
                                        {`https://{bucket}.s3.amazonaws.com/{filepath}`}
                                        <br />
                                        {`s3://{bucket}/{filepath}`}
                                    </div>
                                </li>
                            )}

                            {/*{supportedFileFormats && (*/}
                            {/*    <li>*/}
                            {/*        <p className={"dot"}>{t(`common::label::${"Supported file formats"}`)}</p>*/}
                            {/*        <div className={"text-secondary"}>{supportedFileFormats.join(" ")}</div>*/}
                            {/*    </li>*/}
                            {/*)}*/}
                        </ul>
                    </div>
                </div>
            </Popper>
        </div>
    );
};

export default UploadablefileGuideTooltip;
